"use client";

import { createContext, useContext, ReactNode } from "react";

type MaturityModelContextType = {
  hasSelectedItems: boolean;
  hasSelectedChallenge: boolean;
};

const MaturityModelContext = createContext<MaturityModelContextType | null>(
  null,
);

export const useMaturityModelContext = () => useContext(MaturityModelContext);

type MaturityModelProviderProps = {
  children: ReactNode;
  hasSelectedItems: boolean;
  hasSelectedChallenge: boolean;
};

export const MaturityModelProvider = ({
  children,
  hasSelectedItems,
  hasSelectedChallenge,
}: MaturityModelProviderProps) => (
  <MaturityModelContext.Provider
    value={{ hasSelectedItems, hasSelectedChallenge }}
  >
    {children}
  </MaturityModelContext.Provider>
);
